import { render, staticRenderFns } from "./videoUploadMore.vue?vue&type=template&id=24ece4f4&scoped=true"
import script from "./videoUploadMore.vue?vue&type=script&lang=js"
export * from "./videoUploadMore.vue?vue&type=script&lang=js"
import style0 from "./videoUploadMore.vue?vue&type=style&index=0&id=24ece4f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ece4f4",
  null
  
)

export default component.exports